// extracted by mini-css-extract-plugin
module.exports = {"root":"TableRow-root-3zRfW","body":"TableRow-body-3tozE"};